var module = angular.module('sdCompanyProfileModule');
module.directive('companyProfileNotice', function () {
    return {
        restrict: 'E',
        templateUrl: '/account/tpl/notice.html',
        scope: {
            text: '=',
            open: '=',
            type: '=' /* danger | warning | success | secondary | notice - only for backward compatibility */
        }
    };
});
